import { render, staticRenderFns } from "./supplierAdvance.vue?vue&type=template&id=20aff55c&scoped=true&"
import script from "./supplierAdvance.vue?vue&type=script&lang=js&"
export * from "./supplierAdvance.vue?vue&type=script&lang=js&"
import style0 from "./supplierAdvance.vue?vue&type=style&index=0&id=20aff55c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aff55c",
  null
  
)

export default component.exports